// -- MobX
import { makeAutoObservable } from "mobx";
// -- Services
import PortalService from "../../services/PortalService";
// -- Models
import { Service } from "../../models/Service";
import { ServiceSearch } from "../../models/ServiceSearch";

class ServiceSearchStore {
   /** The current values for the criteria to search */
   searchCriteria: ServiceSearch;
   /** The current list of services  */
   searchResults: Service[];
   /** Indicates if an initial search has been performed */
   initialSearch: boolean;
   /** Indicates if services are currently being search */
   isLoading: boolean;

   constructor() {
      makeAutoObservable(this);
      this.searchCriteria = {} as ServiceSearch;
      this.searchResults = [] as Service[];
      this.initialSearch = false;
      this.isLoading = false;
   }

   public clearSearchCriteria(): void {
      this.searchCriteria = {} as ServiceSearch;
   }

   public searchIsEmpty() {
      return (
         (!this.searchCriteria.name || this.searchCriteria.name.length <= 0) &&
         (!this.searchCriteria.caseNumber ||
            this.searchCriteria.caseNumber.length <= 0) &&
         (!this.searchCriteria.participantName ||
            this.searchCriteria.participantName.length <= 0) &&
         (!this.searchCriteria.serviceAddress ||
            this.searchCriteria.serviceAddress.length <= 0)
      );
   }

   public async searchServices() {
      // Flip the booleans so we can give visual feedback that a search is being performed
      this.isLoading = true;
      this.initialSearch = true;

      await PortalService.SearchServicesAsync(this.searchCriteria)
         .then((res) => (this.searchResults = res))
         .finally(() => (this.isLoading = false));
   }

   public update(property: keyof ServiceSearch, value: any): void {
      (this.searchCriteria as any)[property] =
         value instanceof HTMLInputElement
            ? (value as HTMLInputElement).value
            : value;
   }
}

export default new ServiceSearchStore();
